import { render, staticRenderFns } from "./text-scroll.vue?vue&type=template&id=b2376ed0&scoped=true&"
import script from "./text-scroll.vue?vue&type=script&lang=js&"
export * from "./text-scroll.vue?vue&type=script&lang=js&"
import style0 from "./text-scroll.vue?vue&type=style&index=0&id=b2376ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2376ed0",
  null
  
)

export default component.exports